import { Box, Divider } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { getServicePageRoute } from "../../../../routers/routeUtils";

import { Service } from "../../types/service.type";

import ProgramCardBody from "./ProgramCardBody";
import ProgramCardFooter from "./ProgramCardFooter";
import ProgramCardHeader from "./ProgramCardHeader";

export const ProgramCard = ({ service, width = "390px" }: { service: Service; width?: string }) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate(getServicePageRoute(service.id, service.type));
  };

  return (
    <Box onClick={handleCardClick} sx={styles.container(width)}>
      <ProgramCardHeader service={service} />
      <ProgramCardBody service={service} />
      <Divider orientation="horizontal" sx={{ borderColor: "var(--Gray-200, #EAECF0)" }} />
      <ProgramCardFooter service={service} />
    </Box>
  );
};

const styles = {
  container: (width: string) => ({
    width: { xs: "100%", md: width },
    height: "430px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    borderRadius: "8px",
    border: "1px solid #D2D7DF",
    background: "linear-gradient(180deg, rgba(255, 255, 255, 0.00) 29.68%, rgba(17, 17, 17, 0.15) 100%), #FFF",
    boxShadow: "0 12px 20px 0 rgba(0, 0, 0, 0.04), 0 0 2px 0 rgba(0, 0, 0, 0.06)",

    overflow: "hidden",
    flexShrink: 0,
    cursor: "pointer",
    transition: "box-shadow 0.2s ease-in-out",
    "&:hover": {
      boxShadow: "0px 16px 24px 0px rgba(0, 0, 0, 0.1), 0px 2px 4px 0px rgba(0, 0, 0, 0.1)",
    },
  }),
};
